import List from 'components/grid/list/components/list';
import Loader from 'components/grid/list/components/loader';
import Table from 'components/grid/table';
import Filters from 'components/grid/list/components/filters';
import FormFilters from 'components/grid/list/components/form-filters';
import Pagination from 'components/grid/list/components/pagination';
import Empty from 'components/grid/table/components/empty';

export const ListComponents = {
  Table,
  Empty,
  Filters,
  FormFilters,
  Loader,
  Pagination,
};

export default Object.assign(List, ListComponents);
